import { Card } from 'antd';
import { DashboardOutlined } from '@ant-design/icons';
import { AdminDashboard } from '../../components/dashboard';
import { usePageTitle } from '../../hooks';
import { PageHeader } from '../../components/common/PageHeader';
import './home.css';

/**
 * Home del admin Cyberagropolis (user_type=1). El route guard
 * `RoleBasedHomeRedirect` ya envía al resto de perfiles a su propio
 * `/dashboard`, así que aquí sólo entra el admin global.
 *
 * El contenido lo renderiza íntegramente `<AdminDashboard>`, que
 * mantiene sus propios subtabs (Auditorías / Producción / Superficie
 * / Por provincia) con un único selector de campaña compartido.
 * Estilo alineado con /audits y /planning-groups (Card + PageHeader).
 */
export const Home = () => {
  usePageTitle('Panel admin');

  return (
    <Card className="home-page">
      <PageHeader
        icon={<DashboardOutlined />}
        accent="#1677FF"
        title="Panel admin"
        subtitle="KPIs y rankings por campaña — auditorías, producción y superficie"
      />
      <AdminDashboard />
    </Card>
  );
};
